/**
 * 业务线(M-01)。**单点定义在这里,三端引用。**
 *
 *   transport    客户已经自己办完海关/边检手续,只要运
 *   full_agency  浙江益达代办审批,办完再运。审批明细不向客户展示(客户明确要求)
 *
 * S-02 就要用它,因为契约的 QuoteInput 里 serviceType 是必填:
 * 试算时要知道这一单要不要算代办服务费(M-13,现在初值 0)。
 * 订单主干那张表是 S-04 的事,但枚举本身现在就必须有一份,
 * 否则 DTO 里会出现第二处 ['transport', 'full_agency'] —— 那正是漂移的起点。
 */
export const SERVICE_TYPE = ['transport', 'full_agency'] as const

export type ServiceType = (typeof SERVICE_TYPE)[number]

export function isServiceType(x: unknown): x is ServiceType {
  return typeof x === 'string' && (SERVICE_TYPE as readonly string[]).includes(x)
}
